module.exports = __webpack_public_path__ + "static/media/IMP24.160ef03d.jpg";